export default {
  Sending_succeeded: 'ส่งเรียบร้อยแล้ว',
  old_password_no: 'รหัสผ่านเดิมไม่สามารถว่างเปล่าได้',
  New_password_no: 'รหัสผ่านใหม่ไม่สามารถว่างเปล่าได้และจะต้องประกอบด้วยตัวเลข 6 ถึง 16 หลักและตัวอักษรภาษาอังกฤษ!',
  Confirm_new_password: 'ยืนยันว่ารหัสผ่านใหม่ไม่สามารถว่างเปล่าได้และประกอบด้วยตัวเลข 6 ถึง 16 หลักและอักขระภาษาอังกฤษ!',
  re_enter: 'หากข้อมูลทั้ง 2 อินพุตไม่สอดคล้องกัน กรุณาป้อนใหม่อีกครั้ง',
  no_identical: 'รหัสผ่านใหม่ไม่สามารถเหมือนกับรหัสผ่านเดิมได้',
  up_password_success: 'เปลี่ยนรหัสผ่านสำเร็จแล้ว',
  Old_password_error: 'รหัสผ่านเก่าผิด',
  modify_successfully: 'การแก้ไขสำเร็จแล้ว',
  up_Phone: 'แก้ไขหมายเลขมือถือเรียบร้อยแล้ว',
  modify_phone: 'เปลี่ยนเบอร์โทรศัพท์มือถือ',
  dialog_tips: 'คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนหมายเลขโทรศัพท์ หากคุณยืนยัน หมายเลขโทรศัพท์เดิมของคุณจะได้รับการตรวจสอบก่อน หลังจากยืนยันแล้ว หมายเลขโทรศัพท์ใหม่ของคุณจะได้รับการตรวจสอบ',
  old_phone_code: 'กรอกรหัสยืนยันเบอร์มือถือเดิมของคุณ',
  Modify_contact_name: 'แก้ไขชื่อผู้ติดต่อ',
  Modify_agent_name: 'แก้ไขชื่อตัวแทน',
  Modify_renewal_fs: 'แก้ไขข้อมูลติดต่อต่ออายุ',
  Modify_detailed_address: 'แก้ไขรายละเอียดที่อยู่',
  org_name: 'แก้ไขชื่อหน่วย',
  verifying_phone: 'กำลังยืนยันหมายเลขโทรศัพท์ใหม่...',
  verifying_phone_tow: 'กำลังตรวจสอบหมายเลขโทรศัพท์เก่า...',
  code_success: 'ส่งรหัสยืนยันเรียบร้อยแล้ว',
  import_phone: 'กรอกรหัสยืนยันหมายเลขโทรศัพท์มือถือใหม่ของคุณ',
  Sending_verification_code: 'กำลังส่งรหัสตรวจสอบ...',
  old_password_yes: 'ผ่านการตรวจสอบหมายเลขโทรศัพท์มือถือเก่าแล้ว',
  New_mobile_number: 'เบอร์โทรศัพท์ใหม่',
  Entera_new_phone: 'กรอกเบอร์โทรศัพท์ใหม่',
  Renewal_contact_information: 'ข้อมูลติดต่อต่ออายุ',
  Account_security: 'เพื่อความปลอดภัยในบัญชีของคุณ โปรดกรอกข้อมูลส่วนตัวของคุณให้ครบถ้วนก่อน',
  take_back: 'หดกลับ',
  Reset_succeeded: 'รีเซ็ตสำเร็จแล้ว',
  row_passwords: 'รหัสผ่านที่คุณป้อนสองครั้งไม่ตรงกัน',
  user_password_no: 'ชื่อผู้ใช้หรือรหัสผ่านไม่สามารถว่างเปล่าได้',
  //共用
  Loggingin: 'กำลังเข้าสู่ระบบ...',
  country: 'กรุณาเลือกภูมิภาคของคุณ',
  country1: 'เลือกภูมิภาคของคุณ',
  loading: 'กำลังโหลด...',
  create_successfully: 'สร้างสำเร็จแล้ว!',
  Pleaseselectanagentfirst: 'กรุณาเลือกตัวแทนก่อน',
  Theminimumsalesquantitysonepiece: 'ปริมาณการขายขั้นต่ำคือหนึ่งชิ้น',
  Pleaseselectservicecardtype: 'กรุณาเลือกประเภทบัตรบริการ',
  Insufficientvoicecardbalance: 'ยอดเงินคงเหลือในการ์ดเสียงไม่เพียงพอ',
  Recordingcardbalanceisinsufficient: 'ยอดเงินคงเหลือในบัตรบันทึกไม่เพียงพอ',
  Insufficientbalanceoflocationcard: 'ยอดเงินคงเหลือในบัตรไม่เพียงพอ',
  InsufficientSOScardbalance: 'ยอดเงินคงเหลือในบัตร SOS ไม่เพียงพอ',
  Fencecardbalanceisinsufficient: 'ยอดเงินคงเหลือในบัตรรั้วไม่เพียงพอ',
  Insufficientvideocardbalance: 'ความสมดุลของการ์ดวิดีโอไม่เพียงพอ',
  Theduplexcardbalanceisinsufficient: 'ยอดเงินคงเหลือในบัตรดูเพล็กซ์ไม่เพียงพอ',
  Insufficientbalanceonvipcard: 'ยอดเงินในบัตร VIP ไม่เพียงพอ',
  Confirmsalesinformation: 'ยืนยันข้อมูลการขาย',
  servicecardpasswordmistake: 'รหัสผ่านบัตรบริการที่คุณป้อนอยู่ในรูปแบบที่ไม่ถูกต้อง',
  Servicecardpasswordinputerror: 'ข้อผิดพลาดในการป้อนรหัสผ่านบัตรบริการ',
  successfulsales: 'ความสำเร็จด้านการขาย',
  Pleaseselecttheunitfirst: 'กรุณาเลือกหน่วยก่อน',
  Yourinputisemptypleasereenter: 'ข้อมูลของคุณว่างเปล่า กรุณาป้อนอีกครั้ง!',
  Theenteredimeinumberisempty: 'หมายเลข IMEI ที่คุณป้อนไม่ถูกต้อง กรุณาป้อนอีกครั้ง!',
  Donotaddrepeatedly: 'กรุณาอย่าเพิ่มเพิ่มเติม!',
  TheQRcodeiswrong: 'รหัส QR ไม่ถูกต้อง',
  TheIMEInumberiswrong: 'หมายเลข IMEI ที่คุณสแกนไม่ถูกต้อง กรุณาสแกนอีกครั้ง!',
  Donotscanthecoderepeatedly: 'กรุณาอย่าสแกนโค้ดซ้ำๆ',
  Pleaseselectausertype: 'กรุณาเลือกประเภทผู้ใช้!',
  Pleaseselectaunit: 'กรุณาเลือกหน่วยของคุณ',
  Userprefixnicknamecannotbeempty: 'ชื่อเล่นคำนำหน้าผู้ใช้ไม่สามารถว่างเปล่าได้!',
  nicknameNoXhx: 'คำนำหน้าชื่อผู้ใช้และชื่อเล่นประกอบด้วยอักขระ 2-26 ตัว',
  PleaseaddIMEInumber: 'กรุณาเพิ่มหมายเลข IMEI!',
  YoucanadduptoIMEIsbyscanningthecode: 'คุณสามารถเพิ่ม IMEI ได้สูงสุด 100 รายการโดยการสแกนรหัส QR!',
  YouhaverepeatedlyaddedIMEIpleasedeleteit: 'หากคุณได้เพิ่ม IMEI ซ้ำ กรุณาลบออก!',
  Yourvoicecardisinsufficient: 'การ์ดเสียงของคุณไม่เพียงพอ กรุณาชาร์จใหม่ก่อน!',
  Yourrecordingcardisinsufficient: 'การ์ดบันทึกของคุณไม่เพียงพอ กรุณาชาร์จก่อน!',
  Yourlocationcardisinsufficient: 'บัตรวางตำแหน่งของคุณไม่เพียงพอ กรุณาเติมเงินก่อน!',
  YourSOScardisinsufficient: 'บัตร SOS ของคุณไม่เพียงพอ กรุณาเติมเงินก่อน!',
  Yourfencecardisinsufficient: 'บัตรรั้วของคุณไม่เพียงพอ กรุณาเติมเงินก่อน!',
  Yourvideocardisinsufficient: 'การ์ดแสดงผลของคุณไม่เพียงพอ กรุณาชาร์จใหม่ก่อน!',
  Yourduplexcardisnotenough: 'บัตรดูเพล็กซ์ของคุณไม่เพียงพอ กรุณาเติมเงินก่อน!',
  Theservicecardpasswordenteredisinthewrongformat: 'รหัสผ่านบัตรบริการที่คุณป้อนอยู่ในรูปแบบที่ไม่ถูกต้อง',
  Pleaseselectaregion: 'กรุณาเลือกภูมิภาค',
  Changeemailaddress: 'แก้ไขที่อยู่อีเมล์',
  Editdetailedaddress: 'แก้ไขรายละเอียดที่อยู่',
  Bindingplatformisenabled: 'แพลตฟอร์มการผูกมัดได้รับการเปิดใช้งานแล้ว',
  Bindingplatformhasbeenclosed: 'แพลตฟอร์มผูกมัดถูกปิดแล้ว',
  Memberdisplayturnedon: 'เปิดการแสดงข้อมูลสมาชิกแล้ว',
  Memberdisplayturnedoff: 'การแสดงข้อมูลสมาชิกถูกปิด',
  Noisecancellationturnedon: 'การลดเสียงรบกวนเปิดอยู่',
  Noisecancellationturnedoff: 'ปิดการลดเสียงรบกวน',
  deleteOrg: 'คุณแน่ใจว่าต้องการลบข้อมูลหน่วยนี้หรือไม่?',
  successfullydeleted: 'ลบสำเร็จแล้ว',
  successfullyset: 'เตรียมพร้อมเพื่อความสำเร็จ',
  Thisgroupisalreadythedefaultgroup: 'กลุ่มนี้เป็นกลุ่มเริ่มต้นแล้ว!',
  deletedUserGroup: 'คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่มที่ผู้ใช้เป็นสมาชิกอยู่?',
  deletedGroup: 'คุณแน่ใจว่าต้องการลบกลุ่มนี้หรือไม่?',
  Youhavenotmodifiedthenoteinformation: 'คุณยังไม่ได้แก้ไขข้อมูลหมายเหตุ',
  Areyousureyouwanttoremovethismember: 'คุณแน่ใจว่าต้องการลบสมาชิกนี้หรือไม่?',
  Pleaseselectamembertoadd: 'กรุณาเลือกสมาชิกที่ต้องการเพิ่ม',
  Memberaddedsuccessfully: 'เพิ่มสมาชิกสำเร็จแล้ว',
  Theservicecardpasswordentered: 'รหัสผ่านบัตรบริการที่คุณป้อนอยู่ในรูปแบบที่ไม่ถูกต้อง',
  Thepasswordsenteredtwiceareinconsistent: 'รหัสผ่านที่คุณป้อนซ้ำไม่ตรงกัน กรุณาป้อนใหม่อีกครั้ง',
  successfullyopened: 'การเปิดใช้งานสำเร็จ!',
  Modifycontactnumber: 'แก้ไขเบอร์ติดต่อ',
  Changeemailaddress: 'แก้ไขที่อยู่อีเมล์',
  Modifymailingaddress: 'แก้ไขที่อยู่จัดส่งทางไปรษณีย์',
  changeusername: 'ปรับเปลี่ยนชื่อเล่น',
  Outofwarrantyandcannotbereplaced: 'ระยะเวลารับประกันหมดอายุแล้วไม่สามารถเปลี่ยนใหม่ได้',
  Recycledsuccessfully: 'การรีไซเคิลที่ประสบความสำเร็จ',
  restarttheterminaltotakeeffect: 'การแก้ไขเสร็จสมบูรณ์แล้ว และเทอร์มินัลจะมีผลหลังจากรีสตาร์ท!',
  UserTalkbackSuspended: 'ฟังก์ชันอินเตอร์คอมของผู้ใช้ถูกระงับ',
  Theuserintercomfunctionisturnedon: 'เปิดใช้งานฟังก์ชั่นอินเตอร์คอมของผู้ใช้แล้ว',
  shakeoff: 'สลัด',
  Shaketodeath: 'เขย่าจนตาย',
  Unitdispatcherison: 'เปิดใช้งานตัวจัดการหน่วยแล้ว',
  Unitdispatcherisclosed: 'เจ้าหน้าที่หน่วยปิดทำการแล้ว',
  Changeuseraffiliation: "คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนองค์กรของผู้ใช้?",
  Pleaseselectauser: 'กรุณาเลือกผู้ใช้',
  PleaseentertheoldIMEIcorrectly: 'กรุณากรอกเลข IMEI เก่า 15 หลักให้ถูกต้อง',
  PleaseenterthenewIMEIcorrectly: 'กรุณากรอก IMEI ใหม่ 15 หลักให้ถูกต้อง',
  Replacedthecardsuccessfully: 'เปลี่ยนบัตรสำเร็จแล้ว',
  TheoriginalIMEIentereddoesnotexist: 'IMEI เดิมที่ป้อนไม่มีอยู่',
  TheenterednewIMEIisalreadyinuse: 'IMEI ใหม่ที่ถูกป้อนถูกใช้ไปแล้ว',
  Cardreplacementfailed: 'การเปลี่ยนการ์ดล้มเหลว',
  Theverificationcodehasexpiredpleasegetitagain: 'รหัสยืนยันหมดอายุ กรุณารับรหัสอีกครั้ง!',
  Pleaseentercorrectverifycode: 'กรุณากรอกรหัสตรวจสอบที่ถูกต้อง!',
  Verificationcodeerror: 'รหัสตรวจสอบไม่ถูกต้อง!',
  Pleaseenteramobilephonenumberinthecorrectformat: 'กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณในรูปแบบที่ถูกต้อง',
  Pleaseselectthelisteninggrouptobeadded: 'กรุณาเลือกกลุ่มตรวจสอบที่คุณต้องการเพิ่ม',
  Confirmtoaddlisteninggroup: 'ยืนยันการเพิ่มกลุ่มการตรวจสอบ?',
  Addedsuccessfully: 'เพิ่มเรียบร้อยแล้ว',
  adding: 'กำลังเพิ่ม...',
  deleting: 'กำลังลบ...',
  Areyousuretodeletethislisteninggroup: 'คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่มการตรวจสอบนี้',
  GPSison: 'GPS เปิดอยู่ รีสตาร์ทเครื่องเพื่อให้ใช้งานได้!',
  GPSisoff: 'GPS ปิดอยู่ กรุณารีสตาร์ทเครื่องเพื่อให้ใช้งานได้!',
  Doyouwanttocontinue: 'ตรวจสอบว่าจะดำเนินการต่อหรือไม่สำหรับผู้ใช้ที่มีบัตรสถานที่ยังไม่หมดอายุ',
  Renewalsuccessful: 'การต่ออายุสำเร็จ!',
  IMEIdoesnotexist: 'IMEI ไม่มีอยู่',
  Insufficientservicecardbalance: 'ยอดเงินในบัตรบริการไม่เพียงพอ',
  andtheterminalneedstoberestarted: 'ต้องรีสตาร์ทเทอร์มินัลเพื่อปรับเปลี่ยนหน่วยที่เกี่ยวข้องสำเร็จ',
  Modifytheaffiliatedunitsuccessfully: 'ปรับเปลี่ยนหน่วยที่เกี่ยวข้องสำเร็จแล้ว',
  rOrg_tips: 'ชื่อบริษัทควรมีความยาว 4-20 ตัวอักษร พร้อมตัวเลข ตัวอักษร และเครื่องหมายขีดล่าง ห้ามเริ่มต้นด้วยเครื่องหมายขีดล่าง',
  rNamep_tips: 'ควรมีอักขระจีน ตัวเลข ตัวอักษร และเครื่องหมายขีดล่าง 2-10 ตัว ไม่สามารถเริ่มต้นด้วยเครื่องหมายขีดล่างได้',
  rNamep_tips20: 'ควรมีความยาว 2-20 ตัวอักษร ตัวเลข ตัวอักษร และเครื่องหมายขีดล่าง ไม่สามารถเริ่มต้นด้วยเครื่องหมายขีดล่างได้',
  rPhone_tips: 'รูปแบบเบอร์มือถือไม่ถูกต้อง',
  rAgent_tips: 'ชื่อตัวแทนควรมีความยาว 4-20 อักขระ พร้อมตัวเลข ตัวอักษร และเครื่องหมายขีดล่าง ไม่สามารถเริ่มต้นด้วยเครื่องหมายขีดล่างได้',
  wAgent_tips: 'ชื่อต้องประกอบด้วยอักขระจีน ตัวเลข ตัวอักษร และเครื่องหมายขีดล่าง 1 ถึง 15 ตัว และไม่สามารถเริ่มต้นด้วยเครื่องหมายขีดล่างได้',
  rGroup_tips: 'ชื่อกลุ่มควรมีความยาว 2-15 ตัวอักษร',
  rGroup2_tips: 'ชื่อกลุ่มประกอบด้วยตัวเลข 2-12 หลักในภาษาจีนและภาษาอังกฤษ',
  rAccount_tips: 'หมายเลขบัญชีต้องไม่เว้นว่างไว้ และต้องมีความยาว 6-20 ตัวอักษร เป็นภาษาอังกฤษ ตัวเลข และเครื่องหมายขีดล่าง',
  rPwd_tips: 'รหัสผ่านควรมีความยาว 6-16 ตัวอักษรและประกอบด้วยตัวเลข',
  rName_tips: 'ควรมีอักขระจีน ตัวเลข ตัวอักษร และเครื่องหมายขีดล่าง 2-7 ตัว ไม่สามารถเริ่มต้นด้วยเครื่องหมายขีดล่างได้',
  rNamep1_tips: 'ชื่อเล่นของผู้ใช้สามารถมีความยาวได้ 2-30 ตัวอักษร',
  rEmail_tips: 'กรุณากรอกอีเมลที่ถูกต้อง',
  rInt_tips: 'กรุณากรอกจำนวนเต็มบวก',
  rInputNum_tips: 'กรุณากรอกหมายเลข',
  rBroad_tips: 'เนื้อหาอินพุตควรเป็นภาษาจีน ตัวเลข และตัวอักษร',
  rVerifyCode_tips: 'รหัสยืนยันมือถือมี 4 หลัก',
  rICCID_tips: 'ICCID ควรมีความยาว 19 หรือ 20 ตัวอักษร หรือเป็นตัวเลข',
  rIMEI_tips: 'IMEI ควรเป็น 15 หลัก',
  removegroupleader: 'คุณแน่ใจหรือไม่ว่าต้องการลบเจ้าของกลุ่มและลบกลุ่มที่สร้างขึ้นเองนี้โดยอัตโนมัติ?',
  removeselfcreatedgroups: 'คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่มที่สร้างเองและลบโดยอัตโนมัติ?',
  removeselfcreatedgroupsTow: 'คุณแน่ใจหรือไม่ว่าต้องการเปลี่ยนหน่วยของผู้ใช้และลบกลุ่มที่ผู้ใช้สร้างเองโดยอัตโนมัติ?',
  PleaseselectSOS: 'กรุณาเลือกผู้ใช้ที่ไม่ได้เปิดใช้งานบริการ SOS',
  Logintimedout: 'หมดเวลาการเข้าสู่ระบบ!',
  Serverconnectionexception: 'การเชื่อมต่อเซิร์ฟเวอร์ผิดปกติ',
  ServerconnectionexceptionLoaing: 'กำลังโหลด...',
  Nolocationtrack: 'ไม่มีการติดตามตำแหน่ง',
  Areyousuretodeletethemember: 'คุณแน่ใจว่าต้องการลบสมาชิกนี้หรือไม่?',
  update_successfully: 'อัปเดตสำเร็จ',
  updatecompleted: 'อัปเดตสำเร็จ',
  Pleaseselecttheexportdaterange: 'กรุณาเลือกช่วงวันที่ส่งออกภายใน 90 วันที่ผ่านมา',
  Thestarttimecannotbegreaterthantheendtime: 'เวลาเริ่มต้นไม่สามารถมากกว่าหรือเท่ากับเวลาสิ้นสุดได้',
  Theendtimecannotbelessthanthestarttime: 'เวลาสิ้นสุดไม่สามารถน้อยกว่าหรือเท่ากับเวลาเริ่มต้นได้',
  Areyousureyouwanttodeletethisfence: 'คุณแน่ใจว่าต้องการลบรั้วนี้หรือไม่?',
  Thefencenameisduplicated: 'ชื่อรั้วซ้ำ กรุณาแก้ไขและลองใหม่อีกครั้ง',
  setptttips: 'กรุณาเลือกช่วงเวลาให้บริการ',
  Pleaseselectareareplacement: 'กรุณาเลือกพื้นที่ที่ต้องการเปลี่ยนแปลง',
  Successfuloperation: 'การดำเนินการสำเร็จ',
  Areyousuretoresettheuserpassword: 'คุณแน่ใจหรือไม่ว่าต้องการกู้คืนรหัสผ่านของผู้ใช้นี้?',
  selectedvipcardTpis: 'การบันทึกการเติมเงินของผู้ใช้บัตร VIP ที่เลือก การระบุตำแหน่ง SOS และการ์ดบริการรั้วจะถูกกรองโดยอัตโนมัติ',
  selectedpttgpscardTpis: 'ผู้ใช้ PTT+GPS ที่เลือกไว้จะถูกกรองบัตรบริการระบุตำแหน่งโดยอัตโนมัติเมื่อเติมเงิน',
  closeAgentTips: 'หลังจากปิดบริการแล้ว ข้อมูลที่เกี่ยวข้องกับบริการจะไม่แสดงให้ผู้ใช้ตัวแทนรองเห็น ผู้ใช้ภายในระยะเวลาบริการสามารถใช้บริการต่อไปได้ การปิดบริการได้รับการยืนยันแล้วหรือไม่',
  vipCardNoTips: 'ฟังก์ชันการบันทึก การระบุตำแหน่ง SOS และรั้วอิเล็กทรอนิกส์ของผู้ใช้บัตร VIP นั้นจะเปิดใช้งานถาวรและไม่จำเป็นต้องเปิดใช้งาน',
  pttCardNoTips: 'ไม่มีบัตรบริการที่ต้องเปิดใช้งาน',
  pointtips1: 'ได้มีการเปิดใช้งานฟังก์ชั่นโทรครั้งเดียวของผู้ใช้แล้ว',
  pointtips2: 'ฟังก์ชันการโทรส่วนตัวของผู้ใช้ถูกปิดใช้งาน',
  LimitspecifiedEnglish: 'เลือก อัปเดต และ หรือ ลบ แทรก ตัดทอน char chr ลงใน substr ascii ประกาศ ดำเนินการ นับ มาสเตอร์ ลบ ดำเนินการ สคริปต์ ฟิลด์ iframe',
  Thecommentcontentcannotcontain: 'หมายเหตุไม่สามารถมี',
  Theagentsremarkscannotcontain: "หมายเหตุของตัวแทนไม่สามารถรวม",
  theagencynamecannotcontain: 'ชื่อตัวแทนไม่สามารถมี',
  Thecompanynamecannotcontain: 'ชื่อหน่วยไม่สามารถมี',
  Thegroupnamecannotcontain: 'ชื่อกลุ่มไม่สามารถมี',
  Usernamecannotcontain: 'ชื่อผู้ใช้ไม่สามารถมี',
  Registeredsuccessfully:'ลงทะเบียนสำเร็จ',
  UnbindingUserTips:'การยกเลิกการเชื่อมโยงจะล้างข้อมูลกลุ่มบริษัททั้งหมดและป้องกันการเข้าสู่ระบบ คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการเชื่อมโยง',
  Failedtocreategrouppleasebinddevicefirst:'สร้างกลุ่มไม่สำเร็จ กรุณาผูกอุปกรณ์ก่อน',
  Devicebindingsuccessful:'การเชื่อมโยงอุปกรณ์สำเร็จ',
  Devicebindingfaileddifferentownership:'การเชื่อมโยงอุปกรณ์ล้มเหลว เจ้าของต่างกัน',
  Devicebindingfailedaccountdoesnotexist:'การเชื่อมโยงอุปกรณ์ล้มเหลว บัญชีไม่มีอยู่',
  Devicebindingfailedalreadybound:'การเชื่อมโยงอุปกรณ์ล้มเหลว เชื่อมโยงแล้ว',
  Devicebindingfailedalreadyexists:'การเชื่อมโยงอุปกรณ์ล้มเหลว เชื่อมโยงแล้ว',
  The_maximum_duration_can_only_be_set_to_60_minutes:'สามารถตั้งค่าระยะเวลาสูงสุดได้เพียง 60 นาทีเท่านั้น',
  SOS_transmission_interval:'ช่วงเวลาการส่งสัญญาณ SOS',
  Please_set_the_SOS_interval:'โปรดตั้งค่าช่วงเวลาการส่งสัญญาณ SOS',
  recyclingServiceCardTips:'เมื่อยืนยันการรีไซเคิลแล้ว ผู้ใช้จะถูกลบออก และบัตรบริการที่ใช้ไปแล้วจะถูกนำไปรีไซเคิล',
  Pleasebindthedevicefirst:'กรุณาลงทะเบียนอุปกรณ์ก่อน'
}
